import React from 'react';
import LegalDocumentBody from '../LegalDocumentBody';
import { useAIStrategyEnabled } from '~/hooks';

type Props = {
    setActiveRightTab?: Function;
};

export default function TermsOfBusiness({ setActiveRightTab }: Props) {
    const aiStrategyEnabled = useAIStrategyEnabled();

    return (
        <LegalDocumentBody
            titleKey="terms-of-business"
            bodyKey="terms-of-business-body"
            extraBodyKey={aiStrategyEnabled ? 'terms-of-business-body-automated-strategies' : undefined}
            setActiveRightTab={setActiveRightTab}
        />
    );
}
